// extracted by css-extract-rspack-plugin
export default {"container":"_83124a0c"};